export default __webpack_public_path__ + "static/media/champions-logo.8f02bbdd.png";